import React from 'react'

import { func, number, string } from 'prop-types'

import { formatCountdown } from 'Pods/Shared/Hooks/useResendCountdown'
import i18n from 'Pods/Shared/I18n'

function Resend({
  locale = 'en',
  secondsLeft,
  onResend,
  onChangeEmail,
}) {
  const t = (key, options) => i18n.t(`auth_modal.code.${key}`, { ns: 'rails', lng: locale, ...options })

  return (
    <p className="auth-modal__resend cgt-body-base">
      {/* The prompt carries its own trailing space so locales without word
          spacing (ja, zh-CN) can omit it. */}
      {t('resend_prompt')}
      {secondsLeft > 0 ? (
        <span className="auth-modal__resend-countdown">
          {t('resend_countdown', { time: formatCountdown(secondsLeft) })}
        </span>
      ) : (
        <button
          type="button"
          className="auth-modal__switch-link auth-modal__resend-link cgt-link-primary-accented"
          onClick={onResend}
        >
          {t('resend_link')}
        </button>
      )}
      <span className="auth-modal__resend-separator" aria-hidden="true">&middot;</span>
      <button
        type="button"
        className="auth-modal__switch-link auth-modal__change-email-link cgt-link-primary-accented"
        onClick={onChangeEmail}
      >
        {t('change_email_link')}
      </button>
    </p>
  )
}

Resend.propTypes = {
  locale: string,
  secondsLeft: number.isRequired,
  onResend: func.isRequired,
  onChangeEmail: func.isRequired,
}

export default Resend
